import { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { TextField, PrimaryButton } from 'office-ui-fabric-react';
import { History } from "history";
import 'react-sortable-tree/style.css';
import { RootState } from 'app/redux/reducer';
import { deleteSpecificationType, getSpecificationTypes, ISpecificationType } from 'app/services/specification';
import { IList, IListFilter, IListState, StatusEnum } from 'app/shared';
import { castThunkAction } from 'app/utils/casting';
import PageTitle from 'components/customs/PageTitle';
import { toggleConfirmDialog } from 'app/redux/system/actions';
import { deleteRecovery, getRecoveries, updateRecovery } from 'app/services/recovery';
import { toggleModal } from 'app/redux/modal/actions';
import BasicTable from 'components/customs/BasicTable';
import PageLayout from 'containers/PageLayout';
import { RouteComponentProps } from 'react-router';

interface OwnProps {
    history: History<any>,
}

function mapStateToProps(state: RootState, ownProps: RouteComponentProps) {
    return {
        ...ownProps,
        language: state.system.language,
        specificationTypes: state.specification.specificationTypes as IList<ISpecificationType[]>
    }
}

function mapDispatchToProps(dispatch: Dispatch) {
    return bindActionCreators({
        toggleConfirmDialog,
        getRecoveries,
        updateRecovery,
        deleteRecovery,
        toggleModal,
        deleteSpecificationType,
        getSpecificationTypes
    }, dispatch);
}

type IListContributorRoleProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & OwnProps;

class ListContributorRoles extends Component<IListContributorRoleProps, IListState> {

    state = {
        type: "specificationType",
        filterObject: {
            title: "",
            status: 1,
            createdOn: ""
        },
        pagerObject: {
            page: 1,
            descending: false,
            pageSize: 20
        },
        activeStatus: StatusEnum.Published
    }

    componentDidMount() {
        this.makeRequest({ ...this.state.pagerObject, ...this.state.filterObject });
        window.addEventListener("keydown", this.onEnterSearch, true);
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.onEnterSearch, true);
    }

    onEnterSearch = (e: any) => {
        if (e.key === "Enter") {
            this.searchList();
        }
    };


    makeRequest(options: IListFilter) {
        if (this.state.filterObject.status === StatusEnum.Deleted) {
            castThunkAction(this.props.getRecoveries(options, this.state.type))
                .then(() => {
                    this.setState({
                        activeStatus: StatusEnum.Deleted,
                    })
                })
        } else {
            castThunkAction(this.props.getSpecificationTypes(options)).then(() => {
                this.setState({
                    activeStatus: this.state.filterObject.status,
                })
            })
        }
    }

    searchList() {
        this.setState({
            pagerObject: {
                page: 1,
                descending: false,
                pageSize: 20
            },
        }, () => {
            this.makeRequest({
                ...this.state.pagerObject,
                ...this.state.filterObject
            })
        })
    }

    renderFilter() {
        return (
            <div className="table-filter row">
                <TextField
                    className="custom-textfield col-md-2"
                    label="Başlık İle Arama"
                    value={this.state.filterObject?.title || ""}
                    autoFocus
                    onChange={(event: any) => {
                        this.setState({
                            filterObject: {
                                ...this.state.filterObject,
                                "title": event.target.value
                            }
                        })
                    }}
                />
                <PrimaryButton
                    text="Arama Yap"
                    className="custom-button"
                    onClick={() => this.makeRequest({ ...this.state.pagerObject, ...this.state.filterObject })}
                    styles={{
                        root: {
                            fontSize: "11px",
                            marginTop: "27px",
                            height: "30px"
                        }
                    }}
                />
            </div>
        )
    }

    renderList() {
        return (
            <BasicTable
                columns={[
                    {
                        columnName: "title",
                        text: "Kategori Adı",
                        col: "col-md-12"
                    }
                ]}
                items={this.props.specificationTypes.list}
                renderOperations={(item: ISpecificationType) => (this.state.activeStatus !== StatusEnum.Deleted ?
                    <>
                        <div className="more" onClick={() => this.props.toggleModal("specificationType", item)}><i className="icon-edit-outline"></i> Düzenle</div>
                        <button onClick={() => {
                            this.props.toggleConfirmDialog(true, {
                                callback: () => {
                                    castThunkAction(this.props.deleteSpecificationType(item.id as string)).then(res => {
                                        if (res) {
                                            this.makeRequest({ ...this.state.pagerObject, ...this.state.filterObject })
                                        }
                                    })
                                }
                            })
                        }}><i className="icon-trash-outline"></i> Sil</button>
                    </> : <>
                        {/* eslint-disable-next-line */}
                        <a onClick={() => {
                            castThunkAction(this.props.updateRecovery(this.state.type, item.id as string)).then(res => {
                                if (res) {
                                    this.searchList()
                                }
                            })

                        }}><i className="icon-trash-outline"></i> Kurtar</a>
                        <button onClick={() => {
                            this.props.toggleConfirmDialog(true, {
                                callback: () => {
                                    castThunkAction(this.props.deleteRecovery(item.id as string)).then(res => {
                                        if (res) {
                                            this.searchList()
                                        }
                                    })
                                }
                            })
                        }}><i className="icon-trash-outline"></i> Kalıcı Olarak Sil</button>
                    </>
                )
                }
                showPager={true}
                totalCount={this.props.specificationTypes.totalCount}
                pageCount={this.props.specificationTypes.pageCount}
                onChangePageSize={(pageSize) => {
                    this.setState({ pagerObject: { ...this.state.pagerObject, pageSize } }, () => this.makeRequest({
                        ...this.state.pagerObject,
                        ...this.state.filterObject,
                        pageSize
                    }))
                }}
                onChangePager={(pageNumber) => {
                    this.setState({ pagerObject: { ...this.state.pagerObject, page: pageNumber } }, () => this.makeRequest({
                        ...this.state.pagerObject,
                        ...this.state.filterObject,
                        page: pageNumber
                    }))
                }}
                pageIndex={this.state.pagerObject.page - 1}
            />
        )
    }

    render() {
        return (
            <PageLayout history={this.props.history} match={this.props.match} location={this.props.location}>
                <div className="page push-all">
                    <PageTitle
                        title="Spesifikasyon Kategori Yönetimi"
                        subTitle="Tüm spesifikasyon kategorilerini aşağıdan görüntüleyebilir, düzenleme yapabilir veya yeni bir spesifikasyon kategorisi ekleyebilirsiniz."
                        backUrl="/specifications"
                        showBack
                        history={this.props.history}
                    />
                    <PrimaryButton
                        onClick={() => this.props.toggleModal("specificationType", {})}
                        iconProps={{ iconName: "Add" }}
                        className="absolute-create"
                        text="Yeni Kategori Ekle"
                        styles={{
                            root: {
                                background: "#62a98e",
                                borderColor: "#5b9e85",
                                color: "#fff"
                            },
                            rootHovered: {
                                background: "#5b9e85",
                                borderColor: "#5b9e85"
                            },
                            rootDisabled: {
                                background: "#ececec"
                            }
                        }}
                    />


                    {this.renderFilter()}
                    {this.renderList()}
                </div>
            </PageLayout>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ListContributorRoles);